function asArray(value) {
    return Array.isArray(value) ? value : [];
}

function splitSupplierName(name) {
    var supplierName = name ? String(name).replace(/^\s+|\s+$/g, "") : "";
    var lines = [];
    var index = 0;

    if (!supplierName) {
        return ["暂无"];
    }

    while (index < supplierName.length) {
        lines.push(supplierName.slice(index, index + 6));
        index += 6;
    }

    return lines;
}

function buildArticleListSections(rankList) {
    var rows = asArray(rankList).map(function(item, index) {
        var nameText = item && (item.name || item.productName) ? (item.name || item.productName) : "暂无";
        var purchasePriceText = item && (item.price || item.price === 0) ? item.price : (item && (item.purchasePrice || item.purchasePrice === 0) ? item.purchasePrice : 0);
        var guidePriceText = item && item.guidePrice ? item.guidePrice : "";
        var unitText = item && (item.unitName || item.unit) ? (item.unitName || item.unit) : "";
        var compareValue = item && (item.compareIncreaseDecrease || item.priceChange) ? (item.compareIncreaseDecrease || item.priceChange) : "";

        return {
            rowKey: "article-row-" + index,
            nameText: nameText,
            purchasePriceText: purchasePriceText,
            guidePriceText: guidePriceText,
            unitText: unitText,
            compareValue: compareValue,
            supplierLines: splitSupplierName(item && item.supplierName),
        };
    });

    if (!rows.length) {
        return [];
    }

    return [{
        sectionKey: "article-list",
        sectionHeader: {
            startDate: "",
            endDate: "",
        },
        rows: rows,
    }];
}

module.exports = {
    buildArticleListSections: buildArticleListSections,
    splitSupplierName: splitSupplierName,
};
